import { BrowserRouter, HashRouter, HashRouterProps } from "react-router-dom"

export const SxRouter = (props: HashRouterProps) => {
    return !window?.electron ? <BrowserRouter {...props} /> : <HashRouter {...props} />
}